<head>
  <title></title>
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
    integrity="sha512-iecdLmaskl7CVkqkXNQ/ZH/XLlvWZOJyj7Yy7tcenmpD1ypASozpmT/E0iPtmFIB46ZmdtAc9eNBvH0H/ZpiBw=="
    crossorigin="anonymous" referrerpolicy="no-referrer" />
</head>

<app-breadcrumb></app-breadcrumb>

<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>

<section>
  <div class="row">
    <div class="col-md-4">
      <div><label for="email" id="main-module-validation" [class.error-label]="isModuleInvalid">Module</label><span
          [class.error-label]="isModuleInvalid" class="mandatory-symbol">*</span></div>
      <mat-select matInput placeholder="Select" [(ngModel)]="selectedMainModuleValue" (closed)="mainModulesearchTxt=''"
        (click)="focusmethod('mainModulefocusSearch')" (keydown.enter)="focusmethod('mainModulefocusSearch')">
        <input type="search" id="mainModulefocusSearch" class="dropdownsearchstyle" [(ngModel)]="mainModulesearchTxt"
          matInput placeholder="Search">
        <mat-option class="unselectStyle" [value]="null"
          (onSelectionChange)="onMainModuleSelect($event,null);">Un-select</mat-option>
        <mat-option *ngFor="let item of moduleValueDropdown | assessmentSearch :mainModulesearchTxt"
          (onSelectionChange)="onMainModuleSelect($event,item)" [value]="item.valueExp">
          {{ item.displayExp }}
        </mat-option>
      </mat-select>
    </div>
  </div>
  <div class="row">
    <div class="search-button-continer btn-align" mat-dialog-actions style="margin-bottom: 5px;">
      <button mat-stroked-button class="searchButton" style="margin-top: 12px;" (click)="search()">
        <i class="fa-solid fa-magnifying-glass"></i> Search
      </button>
    </div>
  </div>
</section>

<section *ngIf="selectedMainModuleValue">
  <div class="position-relative grid-content" style="margin-top: 10px;">
    <div>
      <div class="d-flex justify-content-between">
        <div class="d-flex align-items-center px-3">
          <div class="dropdown">
          </div>
        </div>
        <div class="d-flex gap-3">
          <div id="header-container" *ngIf="grid.length">
            <div class="">
              <div class="search-container">
                <span class="fa fa-search form-control-feedback"></span>
                <input type="text" class="form-control search_input" style="font-size: 12px"
                  placeholder="Search here..." [(ngModel)]="searchValue" />
              </div>
            </div>
          </div>
          <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
            *ngIf="message.dataGridAdmin" (click)="openReorder()" (keydown.enter)="openReorder()">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="#ffffff">
              <path style="fill:'#FFFFFF'"
                d="M10 6.66666C10.8841 6.66666 11.7319 7.01785 12.357 7.64297C12.9822 8.2681 13.3333 9.11594 13.3333 10C13.3333 10.8841 12.9822 11.7319 12.357 12.357C11.7319 12.9821 10.8841 13.3333 10 13.3333C9.11596 13.3333 8.26811 12.9821 7.64299 12.357C7.01787 11.7319 6.66668 10.8841 6.66668 10C6.66668 9.11594 7.01787 8.2681 7.64299 7.64297C8.26811 7.01785 9.11596 6.66666 10 6.66666ZM10 8.33333C9.55799 8.33333 9.13406 8.50893 8.8215 8.82149C8.50894 9.13405 8.33335 9.55797 8.33335 10C8.33335 10.442 8.50894 10.8659 8.8215 11.1785C9.13406 11.4911 9.55799 11.6667 10 11.6667C10.442 11.6667 10.866 11.4911 11.1785 11.1785C11.4911 10.8659 11.6667 10.442 11.6667 10C11.6667 9.55797 11.4911 9.13405 11.1785 8.82149C10.866 8.50893 10.442 8.33333 10 8.33333ZM8.33335 18.3333C8.12501 18.3333 7.95001 18.1833 7.91668 17.9833L7.60835 15.775C7.08335 15.5667 6.63335 15.2833 6.20001 14.95L4.12501 15.7917C3.94168 15.8583 3.71668 15.7917 3.61668 15.6083L1.95001 12.725C1.89901 12.6391 1.88103 12.5376 1.89943 12.4395C1.91784 12.3413 1.97137 12.2532 2.05001 12.1917L3.80835 10.8083L3.75001 10L3.80835 9.16666L2.05001 7.80833C1.97137 7.74678 1.91784 7.65868 1.89943 7.56052C1.88103 7.46236 1.89901 7.36086 1.95001 7.275L3.61668 4.39166C3.71668 4.20833 3.94168 4.13333 4.12501 4.20833L6.20001 5.04166C6.63335 4.71666 7.08335 4.43333 7.60835 4.225L7.91668 2.01666C7.95001 1.81666 8.12501 1.66666 8.33335 1.66666H11.6667C11.875 1.66666 12.05 1.81666 12.0833 2.01666L12.3917 4.225C12.9167 4.43333 13.3667 4.71666 13.8 5.04166L15.875 4.20833C16.0583 4.13333 16.2833 4.20833 16.3833 4.39166L18.05 7.275C18.1583 7.45833 18.1084 7.68333 17.95 7.80833L16.1917 9.16666L16.25 10L16.1917 10.8333L17.95 12.1917C18.1084 12.3167 18.1583 12.5417 18.05 12.725L16.3833 15.6083C16.2833 15.7917 16.0583 15.8667 15.875 15.7917L13.8 14.9583C13.3667 15.2833 12.9167 15.5667 12.3917 15.775L12.0833 17.9833C12.05 18.1833 11.875 18.3333 11.6667 18.3333H8.33335ZM9.37501 3.33333L9.06668 5.50833C8.06668 5.71666 7.18335 6.25 6.54168 6.99166L4.53335 6.125L3.90835 7.20833L5.66668 8.5C5.33335 9.47222 5.33335 10.5278 5.66668 11.5L3.90001 12.8L4.52501 13.8833L6.55001 13.0167C7.19168 13.75 8.06668 14.2833 9.05835 14.4833L9.36668 16.6667H10.6333L10.9417 14.4917C11.9333 14.2833 12.8083 13.75 13.45 13.0167L15.475 13.8833L16.1 12.8L14.3333 11.5083C14.6667 10.5333 14.6667 9.475 14.3333 8.5L16.0917 7.20833L15.4667 6.125L13.4583 6.99166C12.8035 6.2336 11.9153 5.71473 10.9333 5.51666L10.625 3.33333H9.37501Z" />
            </svg>
            <span class="reload_text text-white">Settings</span>
          </div>
          <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
            (keydown.enter)="openAddPopup()" (click)="openAddPopup()">
            <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
            <span class="reload_text text-white">Add New</span>
          </div>
          <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
            (click)="openReport('Excel')" (keydown.enter)="openReport('Excel')" *ngIf="grid.length">
            <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
            <span class="reload_text text-white">Excel Report</span>
          </div>
          <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
            (click)="openReport('Pdf')" (keydown.enter)="openReport('Pdf')" *ngIf="grid.length">
            <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
            <span class="reload_text text-white">PDF Report</span>
          </div>
          <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
            *ngIf="message.isAuditTrailUser" (keydown.enter)="openAuditTrail('overAll',0)"
            (click)="openAuditTrail('overAll',0)">
            <i class="fa-solid fa-clipboard" style="font-size:18px;color:white"></i>
            <span class="reload_text text-white">Audit Trail</span>
          </div>
          <div class="reloadIconContiner d-flex gap-2 justify-content-center align-items-center"
            (click)="refreshGridData()" (keydown.enter)="refreshGridData()">
            <img src="../../../assets/img/cr_module/reload.svg" width="18px" height="18px" alt="reload" />
            <span class="reload_text">Reload</span>
          </div>
        </div>
      </div>
    </div>
    <div class="table-container" *ngIf="grid.length">

      <table class="dynamic-table-container" aria-describedby="table-description">
        <th style="min-width: 60px; text-align: center;"
          [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
          <div style="display: flex;">
            <div>
              <i id="parent-menu-icons" class="fa-solid fa-ellipsis-vertical"></i>
            </div>
          </div>
        </th>
        <th id="grid-header-container" *ngFor="let riskScaleTable of columnLists.fieldColumnarray; let ix = index;"
          [ngStyle]="{'min-width': riskScaleTable.width,'max-width': riskScaleTable.width,'overflow': 'hidden',
                    'text-overflow': 'ellipsis',
                    'white-space': 'nowrap'}" class="sticky-dynamic-col1" (mouseover)="cssFunction(0)"
          (focus)="focusEmpty()">
          <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
            <span>{{ riskScaleTable.fieldColumnarray }}</span>
            <div class="d-flex gap-2 align-items-center">
              <div (click)="sortColumn(columnLists.columnsListarray[ix],riskScaleTable)"
                (keydown.enter)="sortColumn(columnLists.columnsListarray[ix],riskScaleTable)">
                <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
              </div>
            </div>
          </div>

          <div class="row-search-container"><input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter3(columnLists.columnsListarray[ix], $event)" /> </div>

        </th>
        <th id="menu" class="sticky-col first-col"></th>

        <tr *ngFor="let list of pagedItems let idx = index;">
          <td style="min-width: 60px; text-align: center;"
            [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
            <div style="display: flex;">
              <div [ngClass]="list.childCheckBox ?'static_icon':'hover-menu-icons'">
                <i class="fa-solid fa-ellipsis-vertical"></i>
              </div>
              <div>
                <input type="checkbox" style="zoom: 1.2;" [checked]="list.childCheckBox"
                  (change)="dataGridChildCheckBoxChecked($event, list, idx)">
              </div>
            </div>
          </td>
          <td id="grid-row-container" *ngFor="let key of columnLists.columnsListarray1; let i = index;"
            class="sticky-dynamic-row1" [ngStyle]="{'min-width': key.width[i] != undefined ? key.width[i] : '200px','max-width': key.width[i] != undefined ? key.width[i] : '200px','overflow': 'hidden',
                        'text-overflow': 'ellipsis',
                        'white-space': 'nowrap'}" (mouseover)="cssFunction(i)" (focus)="focusEmpty()"
            (click)="openEditPopup(list)" (keydown.enter)="openEditPopup(list)">
            <span *ngIf="key.dataType=='CHECKBOX'">
              <div class="gridCheckBoxes">
                <img *ngIf="list[key.columnsListarray]" src="../../assets/img/accessSymbol.svg" alt="Yes" width="20"
                  height="20">
                <img *ngIf="list[key.columnsListarray]==false" src="../../assets/img/noAcessSymbol.svg" alt="No"
                  width="20" height="20">
              </div>
            </span>
            <span *ngIf="key.dataType!='CHECKBOX' && key.dataType!='DATE'">{{
              list[key.columnsListarray] }}</span>
            <span *ngIf="key.dataType=='DATE'">{{ list[key.columnsListarray] }}</span>
          </td>
          <td class="sticky-col first-col">
            <div class="action-icons">
              <i class="fa-solid fa-pencil" matTooltip="Edit" style="margin-left: 5px;" (click)="openEditPopup(list)"
                (keydown.enter)="openEditPopup(list)"></i>
              <i class="fa-sharp fa-solid fa-trash" matTooltip="Delete" style="margin-left: 5px;"
                (click)="openDeletePopup(list)" (keydown.enter)="openDeletePopup(list)"></i>
              <img *ngIf="message.isAuditTrailUser" matTooltip="Audit Trail" alt="Trail" width="20" height="20"
                src="../../assets/img/trail-individual.svg" (click)="openAuditTrail('individual',list)"
                (keydown.enter)="openAuditTrail('individual',list)" />
            </div>
          </td>
        </tr>
      </table>
      <div class="d-flex justify-content-center">
        <div class="width-cheat small paginationCell">
          <div class="d-flex align-items-center gap-3">
            <div class="pagination_text mt-3">
              {{ showingRowsText }}
              1-{{ perPage }} of {{ collectionSize | number }}
            </div>
            <div>
              <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage, $event)" [disabled]="false"
                [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
                [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
              </ngb-pagination>
            </div>
            <div ngbDropdown class="mt-3">
              <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" id="dropdownBasic1"
                ngbDropdownToggle>
                {{ perPage }}
                <i class="ms-1 fa-solid fa-chevron-down"></i>
              </button>
              <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                <button ngbDropdownItem (click)="paginationCall(10)">10</button>
                <button ngbDropdownItem (click)="paginationCall(20)">20</button>
                <button ngbDropdownItem (click)="paginationCall(50)">50</button>
              </div>
              per page
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<ng-template #addAndEditPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelAddAndEditFunction()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{ popupTitle }}</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="form-continer">
      <div class="row">
        <div class="col-md-3">
          <!-- Module -->
          <div><label id="module-validation" for="email">{{dynamicLabel['MODULE']}}</label><span
              class="mandatory-symbol">*</span></div>

          <mat-select matInput placeholder="Select"
            [ngClass]="{'odd-item-mat-select': oddModuleValue == selectedModuleValue}" [(ngModel)]="selectedModuleValue"
            (closed)="modulesearchTxt=''" (click)="focusmethod('modulefocusSearch')"
            (keydown.enter)="focusmethod('modulefocusSearch')" [disabled]="selectedModuleValue">
            <input type="search" id="modulefocusSearch" class="dropdownsearchstyle" [(ngModel)]="modulesearchTxt"
              matInput placeholder="Search">
            <mat-option class="unselectStyle" [value]="null"
              (onSelectionChange)="onModuleSelect($event,null);">Un-select</mat-option>
            <mat-option *ngFor="let item of moduleListDropdown | assessmentSearch :modulesearchTxt"
              (onSelectionChange)="onModuleSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-5">
          <!-- Group List -->
          <div><label id="groupList-validation" for="email">{{dynamicLabel['GROUP_LIST_NAMES']}}</label><span
              class="mandatory-symbol">*</span>
          </div>
          <mat-select matInput multiple placeholder="Select" #groupList [(ngModel)]="selectedGroupList"
            (closed)="groupListSearchText=''" (click)="focusSearch('groupListStatusfocus')"
            (keydown.enter)="focusSearch('groupListStatusfocus')">
            <input type="search" id="groupListStatusfocus" class="dropdownsearchstyle" [(ngModel)]="groupListSearchText"
              matInput placeholder="Search">
            <div class="select-all">
              <mat-checkbox [(ngModel)]="isGroupListSelected" (change)="toggleAllSelection('groupList')">Select
                All</mat-checkbox>
            </div>
            <mat-option *ngFor="let item1 of groupListDropdown | multiAssessmentSearchPipe :groupListSearchText"
              [value]="item1.valueExp" (onSelectionChange)="onGroupListSelect($event, item1)">
              {{ item1.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-3" *ngIf="selectedMainModuleValue !='CC'">
          <!-- Module Type -->
          <div><label id="moduleType-validation" for="email">{{dynamicLabel['MODULE_TYPE']}}</label><span
              class="mandatory-symbol">*</span>
          </div>
          <mat-select matInput placeholder="Select"
            [ngClass]="{'odd-item-mat-select': oddModuleType == selectedModuleType}" [(ngModel)]="selectedModuleType"
            (closed)="moduleTypesearchTxt=''" (click)="focusmethod('moduleTypefocusSearch')"
            (keydown.enter)="focusmethod('moduleTypefocusSearch')">
            <input type="search" id="moduleTypefocusSearch" class="dropdownsearchstyle"
              [(ngModel)]="moduleTypesearchTxt" matInput placeholder="Search">
            <mat-option class="unselectStyle" [value]="null"
              (onSelectionChange)="onModuleTypeSelect($event,null);">Un-select</mat-option>
            <mat-option *ngFor="let item of moduleTypeListDropdown | assessmentSearch :moduleTypesearchTxt"
              (onSelectionChange)="onModuleTypeSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-1">
          <div><label for="email">{{dynamicLabel['STOP_EMAILS']}}</label></div>
          <!-- Stop Emails -->
          <mat-slide-toggle color="primary" [(ngModel)]="qmsNotificationSettingsFieldData.stopEmails">
            <span class="active-inActive-container" *ngIf="qmsNotificationSettingsFieldData.stopEmails==true"
              [ngStyle]="qmsNotificationSettingsFieldData.stopEmails == true?{'color':'green'} : {'color': ''}">Yes</span>
            <span *ngIf="qmsNotificationSettingsFieldData.stopEmails==false"
              [ngStyle]="qmsNotificationSettingsFieldData.stopEmails == false?{'color':'red'} : {'color': ''}">No</span>
          </mat-slide-toggle>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6"
          [hidden]="selectedMainModuleValue=='AU' || selectedMainModuleValue =='IN' || selectedMainModuleValue =='QI' || selectedMainModuleValue =='CC'">
          <fieldset class="border p-2 crFieldsetStyle">
            <legend class="float-none w-auto p-2"><span class="legent-title">Owner Acceptance Reminder</span></legend>
            <div class="row">
              <div class="col-md-6">
                <!-- Owner Acceptance (Due Days) -->
                <div><label for="email">{{dynamicLabel['OWNER_ACCEPTANCE_DUE_DAYS']}} <span class="inDaysStyle">(Due
                      Days)</span></label></div>
                <input id="withdrawalReviewReminderDays" class="input-filed-continers" type="number" min="1"
                  [(ngModel)]="qmsNotificationSettingsFieldData.ownerAcceptanceDueDays"
                  (keydown)="validateNoOfDigitsFields($event)">
              </div>
              <div class="col-md-6">
                <!-- Owner Acceptance Reminder (In Days) -->
                <div><label for="email">{{dynamicLabel['OWNER_ACCEPTANCE_REMINDER_DAYS']}} <span class="inDaysStyle">(In
                      Days)</span></label>
                </div>
                <input id="ownerAcceptanceReminderDays" class="input-filed-continers" type="number" min="1"
                  [(ngModel)]="qmsNotificationSettingsFieldData.ownerAcceptanceReminderDays"
                  (keydown)="validateNoOfDigitsFields($event)">
              </div>
            </div>
          </fieldset>
        </div>
        <div class="col-md-6"
          [hidden]="selectedMainModuleValue =='AU' || selectedMainModuleValue =='IN' || selectedMainModuleValue =='QI' || selectedMainModuleValue=='CC'">
          <fieldset class="border p-2 crFieldsetStyle">
            <legend class="float-none w-auto p-2"><span class="legent-title">QA Acceptance Reminder</span></legend>
            <div class="row">
              <div class="col-md-6">
                <!-- QA Acceptance (Due Days)-->
                <div><label for="email">{{dynamicLabel['QA_ACCEPTANCE_DUE_DAYS']}}<span class="inDaysStyle">(Due
                      Days)</span></label></div>
                <input id="qaAcceptanceDuedays" class="input-filed-continers" type="number" min="1"
                  [(ngModel)]="qmsNotificationSettingsFieldData.qaAcceptanceDueDays"
                  (keydown)="validateNoOfDigitsFields($event)">
              </div>
              <div class="col-md-6">
                <!-- QA Acceptance Reminder (In Days) -->
                <div><label for="email">{{dynamicLabel['QA_ACCEPTANCE_REMINDER_DAYS']}} <span class="inDaysStyle">(In
                      Days)</span></label></div>
                <input id="qaAcceptanceRememberdays" class="input-filed-continers" type="number" min="1"
                  [(ngModel)]="qmsNotificationSettingsFieldData.qaAcceptanceReminderDays"
                  (keydown)="validateNoOfDigitsFields($event)">
              </div>
            </div>
          </fieldset>
        </div>
        <div class="col-md-6"
          [hidden]="selectedMainModuleValue=='AU' || selectedMainModuleValue=='IN' || selectedMainModuleValue=='QI' || selectedMainModuleValue=='CC'">
          <fieldset class="border p-2 crFieldsetStyle">
            <legend class="float-none w-auto p-2"><span class="legent-title">Department Head Reminder</span></legend>
            <div class="row">
              <div class="col-md-6">
                <!-- QA Acceptance (Due Days)-->
                <div><label for="email">{{dynamicLabel['DEPARTMENT_HEAD_APPROVAL_DUE_DAYS']}}<span
                      class="inDaysStyle">(Due Days)</span></label></div>
                <input id="departmentHeadApprovalDueDays" class="input-filed-continers" type="number" min="1"
                  [(ngModel)]="qmsNotificationSettingsFieldData.departmentHeadApprovalDueDays"
                  (keydown)="validateNoOfDigitsFields($event)">
              </div>
              <div class="col-md-6">
                <!-- QA Acceptance Reminder (In Days) -->
                <div><label for="email">{{dynamicLabel['DEPARTMENT_HEAD_APPROVAL_REMINDER_DAYS']}} <span
                      class="inDaysStyle">(In Days)</span></label></div>
                <input id="departmentHeadApprovalReminderDays" class="input-filed-continers" type="number" min="1"
                  [(ngModel)]="qmsNotificationSettingsFieldData.departmentHeadApprovalReminderDays"
                  (keydown)="validateNoOfDigitsFields($event)">
              </div>
            </div>
          </fieldset>
        </div>
        <div class="col-md-6" [hidden]="selectedMainModuleValue =='AU' ||selectedMainModuleValue =='IN'">
          <fieldset class="border p-2 crFieldsetStyle">
            <legend class="float-none w-auto p-2"><span class="legent-title">QA Approval Reminder </span></legend>
            <div class="row">
              <div class="col-md-6">
                <!-- QA Approval (Due Days) -->
                <div><label for="email">{{dynamicLabel['QA_APPROVAL_DUE_DAYS']}}<span class="inDaysStyle">(Due
                      Days)</span></label></div>
                <input id="qaApprovalDueDays" class="input-filed-continers" type="number" min="1"
                  [(ngModel)]="qmsNotificationSettingsFieldData.qaApprovalDueDays"
                  (keydown)="validateNoOfDigitsFields($event)">
              </div>
              <div class="col-md-6">
                <!-- QA Approval Reminder (In Days) -->
                <div><label for="email">{{dynamicLabel['QA_APPROVAL_REMINDER_DAYS']}}<span class="inDaysStyle">(In
                      Days)</span></label></div>
                <input id="qaApprovalReminderDays" class="input-filed-continers" type="number" min="1"
                  [(ngModel)]="qmsNotificationSettingsFieldData.qaApprovalReminderDays"
                  (keydown)="validateNoOfDigitsFields($event)">
              </div>
            </div>
          </fieldset>
        </div>
        <div class="col-md-6"
          [hidden]="selectedMainModuleValue=='CR' || selectedMainModuleValue =='CAPA' || selectedMainModuleValue =='DV' || selectedMainModuleValue =='AU'">
          <fieldset class="border p-2 crFieldsetStyle">
            <legend class="float-none w-auto p-2"><span class="legent-title">Evaluation Reminder</span></legend>
            <div class="row">
              <div class="col-md-6">
                <!-- Evaluation (Due Days) -->
                <div><label for="email">{{dynamicLabel['EVALUATION_DUE_DAYS']}}<span class="inDaysStyle">(Due
                      Days)</span></label></div>
                <input id="evaluationDueDays" class="input-filed-continers" type="number" min="1"
                  [(ngModel)]="qmsNotificationSettingsFieldData.evaluationDueDays"
                  (keydown)="validateNoOfDigitsFields($event)">
              </div>
              <div class="col-md-6">
                <!-- Evaluation Reminder (In Days) -->
                <div><label for="email">{{dynamicLabel['EVALUATION_REMINDER_DAYS']}}<span class="inDaysStyle">(In
                      Days)</span></label></div>
                <input id="evaluationReminderDays" class="input-filed-continers" type="number" min="1"
                  [(ngModel)]="qmsNotificationSettingsFieldData.evaluationReminderDays"
                  (keydown)="validateNoOfDigitsFields($event)">
              </div>
            </div>
          </fieldset>
        </div>
        <div class="col-md-6"
          [hidden]="selectedMainModuleValue =='CR' || selectedMainModuleValue =='CAPA' || selectedMainModuleValue =='AU'">
          <fieldset class="border p-2 crFieldsetStyle">
            <legend class="float-none w-auto p-2"><span class="legent-title">Investigation Reminder</span></legend>
            <div class="row">
              <div class="col-md-6">
                <!-- Investigation (Due Days) -->
                <div><label for="email">{{dynamicLabel['INVESTIGATION_DUE_DAYS']}}<span class="inDaysStyle">(Due
                      Days)</span></label></div>
                <input id="investigationDueDays" class="input-filed-continers" type="number" min="1"
                  [(ngModel)]="qmsNotificationSettingsFieldData.investigationDueDays"
                  (keydown)="validateNoOfDigitsFields($event)">
              </div>
              <div class="col-md-6">
                <!--Investigation Reminder (In Days) -->
                <div><label for="email">{{dynamicLabel['INVESTIGATION_REMINDER_DAYS']}}<span class="inDaysStyle">(In
                      Days)</span></label></div>
                <input id="investigationReminderDays" class="input-filed-continers" type="number" min="1"
                  [(ngModel)]="qmsNotificationSettingsFieldData.investigationReminderDays"
                  (keydown)="validateNoOfDigitsFields($event)">
              </div>
            </div>
          </fieldset>
        </div>
        <div class="col-md-6"
          [hidden]="selectedMainModuleValue =='CR' || selectedMainModuleValue =='CAPA' || selectedMainModuleValue =='DV' || selectedMainModuleValue =='AU'">
          <fieldset class="border p-2 crFieldsetStyle">
            <legend class="float-none w-auto p-2"><span class="legent-title">Log Reminder</span></legend>
            <div class="row">
              <div class="col-md-6">
                <!-- Log (Due Days) -->
                <div><label for="email">{{dynamicLabel['LOG_DUE_DAYS']}}<span class="inDaysStyle">(Due
                      Days)</span></label></div>
                <input id="logDueDays" class="input-filed-continers" type="number" min="1"
                  [(ngModel)]="qmsNotificationSettingsFieldData.logDueDays"
                  (keydown)="validateNoOfDigitsFields($event)">
              </div>
              <div class="col-md-6">
                <!-- Log Reminder(In Days) -->
                <div><label for="email">{{dynamicLabel['LOG_REMINDER_DAYS']}}<span class="inDaysStyle">(In
                      Days)</span></label></div>
                <input id="logReminderDays" class="input-filed-continers" type="number" min="1"
                  [(ngModel)]="qmsNotificationSettingsFieldData.logReminderDays"
                  (keydown)="validateNoOfDigitsFields($event)">
              </div>
            </div>
          </fieldset>
        </div>
        <div class="col-md-6" [hidden]="selectedMainModuleValue != 'AU'">
          <fieldset class="border p-2 crFieldsetStyle">
            <legend class="float-none w-auto p-2"><span class="legent-title">Schedule Approval Remainder</span>
            </legend>
            <div class="row">
              <div class="col-md-6">
                <div>
                  <label for="email">{{dynamicLabel['AU_SCHEDULE_APPROVAL_REMINDER_DAYS']}}
                    <span class="inDaysStyle">(Due Days)</span>
                  </label>
                </div>
                <input id="p-a-p-r-d-d" class="input-filed-continers" type="number" min="1"
                  [(ngModel)]="qmsNotificationSettingsFieldData.auScheduleApprovalReminderDays"
                  (keydown)="validateNoOfDigitsFields($event)">
              </div>
              <div class="col-md-6">
                <div>
                  <label for="email">{{dynamicLabel['AU_SCHEDULE_APPROVAL_DUE_DAYS']}}
                    <span class="inDaysStyle">(In Days)</span>
                  </label>
                </div>
                <input id="p-a-p-r-r-d" class="input-filed-continers" type="number" min="1"
                  [(ngModel)]="qmsNotificationSettingsFieldData.auScheduleApprovalDueDays"
                  (keydown)="validateNoOfDigitsFields($event)">
              </div>
            </div>
          </fieldset>
        </div>
        <div class="col-md-6" [hidden]="selectedMainModuleValue != 'AU'">
          <fieldset class="border p-2 crFieldsetStyle">
            <legend class="float-none w-auto p-2"><span class="legent-title">Plan Approval Remainder</span>
            </legend>
            <div class="row">
              <div class="col-md-6">
                <div>
                  <label for="email">{{dynamicLabel['AU_PLAN_APPROVAL_REMINDER_DAYS']}}
                    <span class="inDaysStyle">(Due Days)</span>
                  </label>
                </div>
                <input id="p-a-p-r-d-d" class="input-filed-continers" type="number" min="1"
                  [(ngModel)]="qmsNotificationSettingsFieldData.auPlanApprovalReminderDays"
                  (keydown)="validateNoOfDigitsFields($event)">
              </div>
              <div class="col-md-6">
                <div>
                  <label for="email">{{dynamicLabel['AU_PLAN_APPROVAL_DUE_DAYS']}}
                    <span class="inDaysStyle">(In Days)</span>
                  </label>
                </div>
                <input id="p-a-p-r-r-d" class="input-filed-continers" type="number" min="1"
                  [(ngModel)]="qmsNotificationSettingsFieldData.auPlanApprovalDueDays"
                  (keydown)="validateNoOfDigitsFields($event)">
              </div>
            </div>
          </fieldset>
        </div>
        <div class="col-md-6">
          <fieldset class="border p-2 crFieldsetStyle">
            <legend class="float-none w-auto p-2"><span class="legent-title">
                {{selectedMainModuleValue =='AU' ? 'Peer' : 'Initial'}} Review Reminder</span>
            </legend>
            <div class="row">
              <div class="col-md-6">
                <!-- Review (Due Days) -->
                <div><label for="email">{{selectedMainModuleValue=='AU' ? 'Peer' : 'Initial'}} Review<span
                      class="inDaysStyle">(Due Days)</span></label></div>
                <input id="initialReviewDueDays" class="input-filed-continers" type="number" min="1"
                  [(ngModel)]="qmsNotificationSettingsFieldData.initialReviewDueDays"
                  (keydown)="validateNoOfDigitsFields($event)">
              </div>
              <div class="col-md-6">
                <div><label for="email">
                    <!-- Review Reminder (In Days) -->
                    {{selectedMainModuleValue=='AU' ? 'Peer' : 'Initial'}} Review Reminder
                    <span class="inDaysStyle">(In Days)</span></label></div>
                <input id="initialReviewReminderDays" class="input-filed-continers" type="number" min="1"
                  [(ngModel)]="qmsNotificationSettingsFieldData.initialReviewReminderDays"
                  (keydown)="validateNoOfDigitsFields($event)">
              </div>
            </div>
          </fieldset>
        </div>
        <div class="col-md-6" [hidden]="selectedMainModuleValue =='AU'">
          <fieldset class="border p-2 crFieldsetStyle">
            <legend class="float-none w-auto p-2"><span class="legent-title">Initial Approval Reminder</span></legend>
            <div class="row">
              <div class="col-md-6">
                <!--Initial Approval (Due Days) -->
                <div><label for="email">{{dynamicLabel['INITIAL_APPROVAL_DUE_DAYS']}}<span class="inDaysStyle">(Due
                      Days)</span></label></div>
                <input id="initialApprovalDueDays" class="input-filed-continers" type="number" min="1"
                  [(ngModel)]="qmsNotificationSettingsFieldData.initialApprovalDueDays"
                  (keydown)="validateNoOfDigitsFields($event)">
              </div>
              <div class="col-md-6">
                <!-- Initial Approval Reminder (In Days) -->
                <div><label for="email">{{dynamicLabel['INITIAL_APPROVAL_REMINDER_DAYS']}}<span class="inDaysStyle">(In
                      Days)</span></label>
                </div>
                <input id="initialApprovalReminderDays" class="input-filed-continers" type="number" min="1"
                  [(ngModel)]="qmsNotificationSettingsFieldData.initialApprovalReminderDays"
                  (keydown)="validateNoOfDigitsFields($event)">
              </div>
            </div>
          </fieldset>
        </div>
        <div class="col-md-6">
          <fieldset class="border p-2 crFieldsetStyle">
            <legend class="float-none w-auto p-2"><span class="legent-title">Closure Review Reminder</span></legend>
            <div class="row">
              <div class="col-md-6">
                <!-- Closure Review (Due Days) -->
                <div><label for="email">{{dynamicLabel['CLOSURE_REVIEW_DUE_DAYS']}} <span class="inDaysStyle">(Due
                      Days)</span></label></div>
                <input id="closureReviewDueDays" class="input-filed-continers" type="number" min="1"
                  [(ngModel)]="qmsNotificationSettingsFieldData.closureReviewDueDays"
                  (keydown)="validateNoOfDigitsFields($event)">
              </div>
              <div class="col-md-6">
                <!-- Closure Review Reminder (In Days) -->
                <div><label for="email">{{dynamicLabel['CLOSURE_REVIEW_REMINDER_DAYS']}}<span class="inDaysStyle">(In
                      Days)</span></label></div>
                <input id="closureReviewReminderDays" class="input-filed-continers" type="number" min="1"
                  [(ngModel)]="qmsNotificationSettingsFieldData.closureReviewReminderDays"
                  (keydown)="validateNoOfDigitsFields($event)">
              </div>
            </div>
          </fieldset>
        </div>
        <div class="col-md-6">
          <fieldset class="border p-2 crFieldsetStyle">
            <legend class="float-none w-auto p-2"><span class="legent-title">Closure Approval Reminder</span></legend>
            <div class="row">
              <div class="col-md-6">
                <!-- Closure Approval (Due Days) -->
                <div><label for="email">{{dynamicLabel['CLOSURE_APPROVAL_DUE_DAYS']}}<span class="inDaysStyle">(Due
                      Days)</span></label></div>
                <input id="closureApprovalDueDays" class="input-filed-continers" type="number" min="1"
                  [(ngModel)]="qmsNotificationSettingsFieldData.closureApprovalDueDays"
                  (keydown)="validateNoOfDigitsFields($event)">
              </div>
              <div class="col-md-6">
                <!-- Closure Approval Reminder (In Days) -->
                <div><label for="email">{{dynamicLabel['CLOSURE_APPROVAL_REMINDER_DAYS']}}<span class="inDaysStyle">(In
                      Days)</span></label>
                </div>
                <input id="closureApprovalReminderDays" class="input-filed-continers" type="number" min="1"
                  [(ngModel)]="qmsNotificationSettingsFieldData.closureApprovalReminderDays"
                  (keydown)="validateNoOfDigitsFields($event)">
              </div>
            </div>
          </fieldset>
        </div>
        <div class="col-md-6" [hidden]="selectedMainModuleValue !='AU'">
          <fieldset class="border p-2 crFieldsetStyle">
            <legend class="float-none w-auto p-2"><span class="legent-title">Findings Completion Reminder</span>
            </legend>
            <div class="row">
              <div class="col-md-6">
                <!-- Findings Response Completion Reminder (In Days) -->
                <div><label for="email">{{dynamicLabel['FINDINGS_RESPONSE_COMPLETION_REMINDER_DAYS']}}<span
                      class="inDaysStyle">(In
                      Days)</span></label></div>
                <input id="findingsResponseCompletionReminderDays" class="input-filed-continers" type="number" min="1"
                  [(ngModel)]="qmsNotificationSettingsFieldData.findingsResponseCompletionReminderDays"
                  (keydown)="validateNoOfDigitsFields($event)">
              </div>
              <div class="col-md-6">
                <!-- Findings Completion Reminder (In Days) -->
                <div><label for="email">{{dynamicLabel['FINDINGS_COMPLETION_REMINDER_DAYS']}}<span
                      class="inDaysStyle">(In Days)</span></label>
                </div>
                <input id="findingsCompletionReminderDays" class="input-filed-continers" type="number" min="1"
                  [(ngModel)]="qmsNotificationSettingsFieldData.findingsCompletionReminderDays"
                  (keydown)="validateNoOfDigitsFields($event)">
              </div>
            </div>
          </fieldset>
        </div>
        <div class="col-md-6" [hidden]="selectedMainModuleValue=='AU'">
          <fieldset class="border p-2 crFieldsetStyle">
            <legend class="float-none w-auto p-2"><span class="legent-title">Action Review Reminder</span></legend>
            <div class="row">
              <div class="col-md-6">
                <!-- Action Review (Due Days) -->
                <div><label for="email">{{dynamicLabel['ACTION_REVIEW_DUE_DAYS']}}<span class="inDaysStyle">(Due
                      Days)</span></label></div>
                <input id="actionReviewDueDays" class="input-filed-continers" type="number" min="1"
                  [(ngModel)]="qmsNotificationSettingsFieldData.actionReviewDueDays"
                  (keydown)="validateNoOfDigitsFields($event)">
              </div>
              <div class="col-md-6">
                <!-- Action Review Reminder (In Days) -->
                <div><label for="email">{{dynamicLabel['ACTION_REVIEW_REMINDER_DAYS']}}<span class="inDaysStyle">(In
                      Days)</span></label></div>
                <input id="actionReviewReminderDays" class="input-filed-continers" type="number" min="1"
                  [(ngModel)]="qmsNotificationSettingsFieldData.actionReviewReminderDays"
                  (keydown)="validateNoOfDigitsFields($event)">
              </div>
            </div>
          </fieldset>
        </div>
        <div class="col-md-6" [hidden]="selectedMainModuleValue =='AU'">
          <fieldset class="border p-2 crFieldsetStyle">
            <legend class="float-none w-auto p-2"><span class="legent-title">Action Approval Reminder</span></legend>
            <div class="row">
              <div class="col-md-6">
                <!-- Action Approval (Due Days) -->
                <div><label for="email">{{dynamicLabel['ACTION_APPROVAL_DUE_DAYS']}}<span class="inDaysStyle">(Due
                      Days)</span></label></div>
                <input id="actionApprovalDueDays" class="input-filed-continers" type="number" min="1"
                  [(ngModel)]="qmsNotificationSettingsFieldData.actionApprovalDueDays"
                  (keydown)="validateNoOfDigitsFields($event)">
              </div>
              <div class="col-md-6">
                <!-- Action Approval Reminder (In Days) -->
                <div><label for="email">{{dynamicLabel['ACTION_APPROVAL_REMINDER_DAYS']}} <span class="inDaysStyle">(In
                      Days)</span></label>
                </div>
                <input id="actionApprovalReminderDays" class="input-filed-continers" type="number" min="1"
                  [(ngModel)]="qmsNotificationSettingsFieldData.actionApprovalReminderDays"
                  (keydown)="validateNoOfDigitsFields($event)">
              </div>
            </div>
          </fieldset>
        </div>

        <div class="col-md-6" [hidden]="selectedMainModuleValue =='AU'">
          <fieldset class="border p-2 crFieldsetStyle">
            <legend class="float-none w-auto p-2"><span class="legent-title">Pre Action Plan Review Reminder</span>
            </legend>
            <div class="row">
              <div class="col-md-6">
                <div>
                  <label for="email">{{dynamicLabel['PRE_ACTION_PLAN_REVIEW_DUE_DAYS']}}
                    <span class="inDaysStyle">(Due Days)</span>
                  </label>
                </div>
                <input id="p-a-p-r-d-d" class="input-filed-continers" type="number" min="1"
                  [(ngModel)]="qmsNotificationSettingsFieldData.preActionPlanReviewDueDays"
                  (keydown)="validateNoOfDigitsFields($event)">
              </div>
              <div class="col-md-6">
                <div>
                  <label for="email">{{dynamicLabel['PRE_ACTION_PLAN_REVIEW_REMINDER_DAYS']}}
                    <span class="inDaysStyle">(In Days)</span>
                  </label>
                </div>
                <input id="p-a-p-r-r-d" class="input-filed-continers" type="number" min="1"
                  [(ngModel)]="qmsNotificationSettingsFieldData.preActionPlanReviewReminderDays"
                  (keydown)="validateNoOfDigitsFields($event)">
              </div>
            </div>
          </fieldset>
        </div>
        <div class="col-md-6" [hidden]="selectedMainModuleValue =='AU'">
          <fieldset class="border p-2 crFieldsetStyle">
            <legend class="float-none w-auto p-2"><span class="legent-title">Pre Action Plan Approval Reminder</span>
            </legend>
            <div class="row">
              <div class="col-md-6">
                <div>
                  <label for="email">{{dynamicLabel['PRE_ACTION_PLAN_APPROVAL_DUE_DAYS']}}
                    <span class="inDaysStyle">(Due Days)</span>
                  </label>
                </div>
                <input id="p-a-p-a-d-d" class="input-filed-continers" type="number" min="1"
                  [(ngModel)]="qmsNotificationSettingsFieldData.preActionPlanApprovalDueDays"
                  (keydown)="validateNoOfDigitsFields($event)">
              </div>
              <div class="col-md-6">
                <div>
                  <label for="email">{{dynamicLabel['PRE_ACTION_PLAN_APPROVAL_REMINDER_DAYS']}}
                    <span class="inDaysStyle">(In Days)</span>
                  </label>
                </div>
                <input id="p-a-p-a-r-d" class="input-filed-continers" type="number" min="1"
                  [(ngModel)]="qmsNotificationSettingsFieldData.preActionPlanApprovalReminderDays"
                  (keydown)="validateNoOfDigitsFields($event)">
              </div>
            </div>
          </fieldset>
        </div>
        <div class="col-md-6" [hidden]="selectedMainModuleValue =='AU'">
          <fieldset class="border p-2 crFieldsetStyle">
            <legend class="float-none w-auto p-2"><span class="legent-title">Pre Action Impl Review Reminder</span>
            </legend>
            <div class="row">
              <div class="col-md-6">
                <div>
                  <label for="email">{{dynamicLabel['PRE_ACTION_REVIEW_DUE_DAYS']}}
                    <span class="inDaysStyle">(Due Days)</span>
                  </label>
                </div>
                <input id="p-a-r-d-d" class="input-filed-continers" type="number" min="1"
                  [(ngModel)]="qmsNotificationSettingsFieldData.preActionReviewDueDays"
                  (keydown)="validateNoOfDigitsFields($event)">
              </div>
              <div class="col-md-6">
                <div>
                  <label for="email">{{dynamicLabel['PRE_ACTION_REVIEW_REMINDER_DAYS']}}
                    <span class="inDaysStyle">(In Days)</span>
                  </label>
                </div>
                <input id="p-a-r-r-d" class="input-filed-continers" type="number" min="1"
                  [(ngModel)]="qmsNotificationSettingsFieldData.preActionReviewReminderDays"
                  (keydown)="validateNoOfDigitsFields($event)">
              </div>
            </div>
          </fieldset>
        </div>
        <div class="col-md-6" [hidden]="selectedMainModuleValue =='AU'">
          <fieldset class="border p-2 crFieldsetStyle">
            <legend class="float-none w-auto p-2"><span class="legent-title">Pre Action Impl Approval Reminder</span>
            </legend>
            <div class="row">
              <div class="col-md-6">
                <div>
                  <label for="email">{{dynamicLabel['PRE_ACTION_APPROVAL_DUE_DAYS']}}
                    <span class="inDaysStyle">(Due Days)</span>
                  </label>
                </div>
                <input id="p-a-a-d-d" class="input-filed-continers" type="number" min="1"
                  [(ngModel)]="qmsNotificationSettingsFieldData.preActionApprovalDueDays"
                  (keydown)="validateNoOfDigitsFields($event)">
              </div>
              <div class="col-md-6">
                <div>
                  <label for="email">{{dynamicLabel['PRE_ACTION_APPROVAL_REMINDER_DAYS']}}
                    <span class="inDaysStyle">(In Days)</span>
                  </label>
                </div>
                <input id="p-a-a-r-d" class="input-filed-continers" type="number" min="1"
                  [(ngModel)]="qmsNotificationSettingsFieldData.preActionApprovalReminderDays"
                  (keydown)="validateNoOfDigitsFields($event)">
              </div>
            </div>
          </fieldset>
        </div>
        <div class="col-md-6">
          <fieldset class="border p-2 crFieldsetStyle">
            <legend class="float-none w-auto p-2"><span class="legent-title">Extension Review Reminder</span></legend>
            <div class="row">
              <div class="col-md-6">
                <!-- Extension Review (Due Days) -->
                <div><label for="email">{{dynamicLabel['EXTN_REVIEW_DUE_DAYS']}}<span class="inDaysStyle">(Due
                      Days)</span></label></div>
                <input id="extnReviewDueDays" class="input-filed-continers" type="number" min="1"
                  [(ngModel)]="qmsNotificationSettingsFieldData.extnReviewDueDays"
                  (keydown)="validateNoOfDigitsFields($event)">
              </div>
              <div class="col-md-6">
                <!-- Extension Review Reminder (In Days) -->
                <div><label for="email">{{dynamicLabel['EXTN_REVIEW_REMINDER_DAYS']}}<span class="inDaysStyle">(In
                      Days)</span></label>
                </div>
                <input id="extnReviewReminderDays" class="input-filed-continers" type="number" min="1"
                  [(ngModel)]="qmsNotificationSettingsFieldData.extnReviewReminderDays"
                  (keydown)="validateNoOfDigitsFields($event)">
              </div>
            </div>
          </fieldset>
        </div>

        <div class="col-md-6">
          <fieldset class="border p-2 crFieldsetStyle">
            <legend class="float-none w-auto p-2"><span class="legent-title">Extension Approval Reminder</span></legend>
            <div class="row">
              <div class="col-md-6">
                <!-- Extension Review (Due Days) -->
                <div><label for="email">{{dynamicLabel['EXTN_APPROVAL_DUE_DAYS']}}<span class="inDaysStyle">(Due
                      Days)</span></label></div>
                <input id="withdrawalApprovalReminderDays" class="input-filed-continers" type="number" min="1"
                  [(ngModel)]="qmsNotificationSettingsFieldData.extnApprovalDueDays"
                  (keydown)="validateNoOfDigitsFields($event)">
              </div>
              <div class="col-md-6">
                <!-- Extension Review Reminder (In Days) -->
                <div><label for="email">{{dynamicLabel['EXTN_APPROVAL_REMINDER_DAYS']}}<span class="inDaysStyle">(In
                      Days)</span></label>
                </div>
                <input id="extnApprovalReminderDays" class="input-filed-continers" type="number" min="1"
                  [(ngModel)]="qmsNotificationSettingsFieldData.extnApprovalReminderDays"
                  (keydown)="validateNoOfDigitsFields($event)">
              </div>
            </div>
          </fieldset>
        </div>
        <div class="col-md-6"
          [hidden]="selectedMainModuleValue=='AU' || selectedMainModuleValue=='IN' || selectedMainModuleValue=='QI' || selectedMainModuleValue=='CC'">
          <fieldset class="border p-2 crFieldsetStyle">
            <legend class="float-none w-auto p-2"><span class="legent-title">Reopen Approval Reminder</span></legend>
            <div class="row">
              <div class="col-md-6">
                <!-- Reopen Review (Due Days) -->
                <div><label for="email">{{dynamicLabel['REOPEN_REVIEW_DUE_DAYS']}} <span class="inDaysStyle">(Due
                      Days)</span></label></div>
                <input id="reopenReviewDueDays" class="input-filed-continers" type="number" min="1"
                  [(ngModel)]="qmsNotificationSettingsFieldData.reopenReviewDueDays"
                  (keydown)="validateNoOfDigitsFields($event)">
              </div>
              <div class="col-md-6">
                <!-- Reopen Review Reminder (In Days) -->
                <div><label for="email">{{dynamicLabel['REOPEN_REVIEW_REMINDER_DAYS']}}<span class="inDaysStyle">(In
                      Days)</span></label></div>
                <input id="reopenReviewReminderDays" class="input-filed-continers" type="number" min="1"
                  [(ngModel)]="qmsNotificationSettingsFieldData.reopenReviewReminderDays"
                  (keydown)="validateNoOfDigitsFields($event)">
              </div>
            </div>
          </fieldset>
        </div>
        <div class="col-md-6"
          [hidden]="selectedMainModuleValue =='AU' || selectedMainModuleValue =='IN' || selectedMainModuleValue =='QI' || selectedMainModuleValue =='CC'">
          <fieldset class="border p-2 crFieldsetStyle">
            <legend class="float-none w-auto p-2"><span class="legent-title">Revoke Approval Reminder</span></legend>
            <div class="row">
              <div class="col-md-6">
                <!-- Revoke Review (Due Days) -->
                <div><label for="email">{{dynamicLabel['REVOKE_REVIEW_DUE_DAYS']}}<span class="inDaysStyle">(Due
                      Days)</span></label></div>
                <input id="revokeReviewDueDays" class="input-filed-continers" type="number" min="1"
                  [(ngModel)]="qmsNotificationSettingsFieldData.revokeReviewDueDays"
                  (keydown)="validateNoOfDigitsFields($event)">
              </div>
              <div class="col-md-6">
                <!-- Revoke Review Reminder (In Days) -->
                <div><label for="email">{{dynamicLabel['REVOKE_REVIEW_REMINDER_DAYS']}}<span class="inDaysStyle">(In
                      Days)</span></label></div>
                <input id="revokeReviewReminderDays" class="input-filed-continers" type="number" min="1"
                  [(ngModel)]="qmsNotificationSettingsFieldData.revokeReviewReminderDays"
                  (keydown)="validateNoOfDigitsFields($event)">
              </div>
            </div>
          </fieldset>
        </div>
        <div class="col-md-6"
          [hidden]="selectedMainModuleValue =='AU' || selectedMainModuleValue =='IN' || selectedMainModuleValue =='QI' || selectedMainModuleValue =='CC'">
          <fieldset class="border p-2 crFieldsetStyle">
            <legend class="float-none w-auto p-2"><span class="legent-title">Delete Approval Reminder</span></legend>
            <div class="row">
              <div class="col-md-6">
                <!-- Delete Review (Due Days) -->
                <div><label for="email">{{dynamicLabel['DELETE_REVIEW_DUE_DAYS']}}<span class="inDaysStyle">(Due
                      Days)</span></label></div>
                <input id="deleteReviewDueDays" class="input-filed-continers" type="number" min="1"
                  [(ngModel)]="qmsNotificationSettingsFieldData.deleteReviewDueDays"
                  (keydown)="validateNoOfDigitsFields($event)">
              </div>
              <div class="col-md-6">
                <!-- Delete Review Reminder (In Days) -->
                <div><label for="email">{{dynamicLabel['DELETE_REVIEW_REMINDER_DAYS']}}<span class="inDaysStyle">(In
                      Days)</span></label></div>
                <input id="deleteReviewReminderDays" class="input-filed-continers" type="number" min="1"
                  [(ngModel)]="qmsNotificationSettingsFieldData.deleteReviewReminderDays"
                  (keydown)="validateNoOfDigitsFields($event)">
              </div>
            </div>
          </fieldset>
        </div>
        <div class="col-md-6"
          [hidden]="selectedMainModuleValue=='AU' || selectedMainModuleValue =='IN' || selectedMainModuleValue =='QI' || selectedMainModuleValue =='CC'">
          <fieldset class="border p-2 crFieldsetStyle">
            <legend class="float-none w-auto p-2"><span class="legent-title">Obsolete Approval Reminder</span></legend>
            <div class="row">
              <div class="col-md-6">
                <!-- Obsolete Review (Due Days) -->
                <div><label for="email">{{dynamicLabel['OBSOLETE_REVIEW_DUE_DAYS']}}<span class="inDaysStyle">(Due
                      Days)</span></label></div>
                <input id="obsoleteReviewDueDays" class="input-filed-continers" type="number" min="1"
                  [(ngModel)]="qmsNotificationSettingsFieldData.obsoleteReviewDueDays"
                  (keydown)="validateNoOfDigitsFields($event)">
              </div>
              <div class="col-md-6">
                <!-- Obsolete Review Reminder (In Days) -->
                <div><label for="email">{{dynamicLabel['OBSOLETE_REVIEW_REMINDER_DAYS']}}<span class="inDaysStyle">(In
                      Days)</span></label>
                </div>
                <input id="obsoleteReviewReminderDays" class="input-filed-continers" type="number" min="1"
                  [(ngModel)]="qmsNotificationSettingsFieldData.obsoleteReviewReminderDays"
                  (keydown)="validateNoOfDigitsFields($event)">
              </div>
            </div>
          </fieldset>
        </div>
        <div class="col-md-6" [hidden]="selectedMainModuleValue =='CC'">
          <fieldset class="border p-2 crFieldsetStyle">
            <legend class="float-none w-auto p-2"><span class="legent-title">Effectiveness Check Reminder</span>
            </legend>
            <div class="row">
              <div class="col-md-6">
                <!-- Effectiveness Check Start Reminder (In Days) -->
                <div><label for="email">{{dynamicLabel['EC_START_REMINDER_DAYS']}}<span class="inDaysStyle">(In
                      Days)</span></label></div>
                <input id="ecStartReminderDays" class="input-filed-continers" type="number" min="1"
                  [(ngModel)]="qmsNotificationSettingsFieldData.ecStartReminderDays"
                  (keydown)="validateNoOfDigitsFields($event)">
              </div>
              <div class="col-md-6">
                <!-- Effectiveness Check Due Reminder (In Days) -->
                <div><label for="email">{{dynamicLabel['EC_DUE_REMINDER_DAYS']}}<span class="inDaysStyle">(In
                      Days)</span></label></div>
                <input id="ecDueReminderDays" class="input-filed-continers" type="number" min="1"
                  [(ngModel)]="qmsNotificationSettingsFieldData.ecDueReminderDays"
                  (keydown)="validateNoOfDigitsFields($event)">
              </div>
            </div>
          </fieldset>
        </div>
        <div class="col-md-6" [hidden]="selectedMainModuleValue=='CC'">
          <fieldset class="border p-2 crFieldsetStyle">
            <legend class="float-none w-auto p-2"><span class="legent-title">Effectiveness Check Approval
                Reminder</span></legend>
            <div class="row">
              <div class="col-md-6">
                <!-- Effectiveness Check Approval (Due Days) -->
                <div><label for="email">{{dynamicLabel['EC_APPROVAL_DUE_DAYS']}}<span class="inDaysStyle">(Due
                      Days)</span></label>
                </div>
                <input id="ecApprovalDueDays" class="input-filed-continers" type="number" min="1"
                  [(ngModel)]="qmsNotificationSettingsFieldData.ecApprovalDueDays"
                  (keydown)="validateNoOfDigitsFields($event)">
              </div>
              <div class="col-md-6">
                <!-- Effectiveness Check Approval Reminder (In Days) -->
                <div><label for="email">{{dynamicLabel['EC_APPROVAL_REMINDER_DAYS']}}<span class="inDaysStyle">(In
                      Days)</span></label></div>
                <input id="ecApprovalReminderDays" class="input-filed-continers" type="number" min="1"
                  [(ngModel)]="qmsNotificationSettingsFieldData.ecApprovalReminderDays"
                  (keydown)="validateNoOfDigitsFields($event)">
              </div>
            </div>
          </fieldset>
        </div>
        <div class="col-md-6" [hidden]="selectedMainModuleValue =='CC'">
          <fieldset class="border p-2 crFieldsetStyle">
            <legend class="float-none w-auto p-2"><span class="legent-title">Effectiveness Check QA Approval
                Reminder</span></legend>
            <div class="row">
              <div class="col-md-6">
                <!-- Effectiveness Check QA Approval (Due Days) -->
                <div><label for="email">{{dynamicLabel['EC_QA_APPROVAL_DUE_DAYS']}}<span class="inDaysStyle">(Due
                      Days)</span></label></div>
                <input id="ecQaApprovalDueDays" class="input-filed-continers" type="number" min="1"
                  [(ngModel)]="qmsNotificationSettingsFieldData.ecQaApprovalDueDays"
                  (keydown)="validateNoOfDigitsFields($event)">
              </div>
              <div class="col-md-6">
                <!-- Effectiveness Check QA Approval Reminder (In Days) -->
                <div><label for="email">{{dynamicLabel['EC_QA_APPROVAL_REMINDER_DAYS']}}<span class="inDaysStyle">(In
                      Days)</span></label></div>
                <input id="ecQaApprovalReminderDays" class="input-filed-continers" type="number" min="1"
                  [(ngModel)]="qmsNotificationSettingsFieldData.ecQaApprovalReminderDays"
                  (keydown)="validateNoOfDigitsFields($event)">
              </div>
            </div>
          </fieldset>
        </div>
        <div class="col-md-3 field-style" [hidden]="selectedMainModuleValue=='AU'">
          <!-- Action Reminder (In Days) -->
          <div><label for="email">{{dynamicLabel['ACTION_REMINDER_DAYS']}}<span class="inDaysStyle">(In
                Days)</span></label></div>
          <input id="actionReminderDays" class="input-filed-continers" type="number" min="1"
            [(ngModel)]="qmsNotificationSettingsFieldData.actionReminderDays"
            (keydown)="validateNoOfDigitsFields($event)">
        </div>
        <div class="col-md-3 field-style" [hidden]="selectedMainModuleValue =='AU'">
          <!-- Overall Closure Date Reminder (In Days) -->
          <div><label for="email">{{dynamicLabel['OVERALL_CLOSURE_DATE_REMINDER_DAYS']}}<span class="inDaysStyle">(In
                Days)</span></label></div>
          <input id="overallClosureDateReminderDays" class="input-filed-continers" type="number" min="1"
            [(ngModel)]="qmsNotificationSettingsFieldData.overallClosureDateReminderDays"
            (keydown)="validateNoOfDigitsFields($event)">
        </div>
        <div class="col-md-3 field-style" [hidden]="selectedMainModuleValue !='AU'">
          <!-- Questionnaire Completion Reminder (In Days) -->
          <div><label for="email">{{dynamicLabel['QUESTIONNAIRE_COMPLETION_REMINDER_DAYS']}}<span
                class="inDaysStyle">(In Days)</span></label>
          </div>
          <input id="questionnaireCompletionReminderDays" class="input-filed-continers" type="number" min="1"
            [(ngModel)]="qmsNotificationSettingsFieldData.questionnaireCompletionReminderDays"
            (keydown)="validateNoOfDigitsFields($event)">
        </div>
        <div class="col-md-3 field-style" [hidden]="selectedMainModuleValue !='AU'">
          <!-- Followup Completion Reminder (In Days) -->
          <div><label for="email">{{dynamicLabel['FOLLOWUP_COMPLETION_REMINDER_DAYS']}}<span class="inDaysStyle">(In
                Days)</span></label></div>
          <input id="followupCompletionReminderDays" class="input-filed-continers" type="number" min="1"
            [(ngModel)]="qmsNotificationSettingsFieldData.followupCompletionReminderDays"
            (keydown)="validateNoOfDigitsFields($event)">
        </div>
        <div class="col-md-4" *ngIf="visibleEditButton">
          <!-- Template Name -->
          <div><label for="email " id="update-validation">{{dynamicLabel['UPDATE_REASON']}}</label><span
              class="mandatory-symbol">*</span></div>
          <textarea id="update" rows="4" class="textarea-filed-continers" type="text"
            [(ngModel)]="qmsNotificationSettingsFieldData.updateReason" (focusout)="onFieldFocusout()"></textarea>
        </div>
      </div>
    </div>
  </div>

  <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (click)="addAndEditFunction(qmsNotificationSettingsFieldData)"
      (keydown.enter)="addAndEditFunction(qmsNotificationSettingsFieldData)" *ngIf="visibleAddButton">
      <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
      <span class="reload_text text-white">Add New</span>
    </div>
    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (click)="addAndEditFunction(qmsNotificationSettingsFieldData)"
      (keydown.enter)="addAndEditFunction(qmsNotificationSettingsFieldData)" *ngIf="visibleEditButton">
      <i class="fas fa-user-edit" style="font-size: 18px; color:white;"></i><span style="color:white;">Update</span>
    </div>
    <button mat-stroked-button class="cancelButton" (click)="cancelAddAndEditFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<ng-template #deletePopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelDeleteFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupTitle }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;">
    <div>
      <div class="row">
        <div class="col-md-12">
          <div><label id="deleteReason-validation" for="email">Reason for Delete</label><span
              class="mandatory-symbol">*</span></div>
          <textarea id="deleteTextarea" type="text" class="input-filed-textarea uppercase" rows="4" cols="50"
            [(ngModel)]="qmsNotificationSettingsFieldData.deleteReason" (focusout)="onFieldFocusout()"></textarea>
        </div>
      </div>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button class="deleteButton" (click)="deleteFunction()">
        <i class="fa fa-trash"></i> Delete
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelDeleteFunction()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<app-dynamic-audit-trail #dynAuditTrailPopup [auditTrail]="auditTrail"></app-dynamic-audit-trail>
<app-excel-pdf #excelPdfPopup [excelPdf]="excelPdf"></app-excel-pdf>
<app-grid-reorder #reorderPopup (valueEmitter)="onChildValueEmitted()"></app-grid-reorder>